module.exports = __webpack_public_path__ + "static/media/wendy_cabrera_rubio_rata.ba4a3c70.png";